import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Card, CardImg, CardBody, CardSubtitle } from 'reactstrap';
import 'react-input-range/lib/css/index.css';
import { veh_data } from '../shared/vehicle_make_and_models';
import './ImgAndForm.css';
import Button from '@material-ui/core/Button';
import cmctModelWomen from '../assets/images/cmct/classic-snacks.jpg';
import cmctModelMen from '../assets/images/cmct/drink-category.png';


class ImgAndForm extends Component {
  constructor(props) {
    super(props);
    this.searchRef = React.createRef();

    this.handleSearch = this.handleSearch.bind(this);
    this.keyToOption = this.keyToOption.bind(this);
    this.toggle = this.toggle.bind(this);
    this.handleMakeChange = this.handleMakeChange.bind(this);
    this.handleModelChange = this.handleModelChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleNav = this.handleNav.bind(this)

    this.state = {
      value4: {
        min: 100,
        max: 5000
      },
      fromPrice: 0,
      toPrice: 75000,
      makeSelected: null,
      modelSelected: 'any',
      typeSelected: 'cars',
      message: '',
      carPrices: [
        0,
        100,
        500,
        1000,
        1500,
        2000,
        2500,
        3000,
        3500,
        4000,
        4500,
        5000,
        5500,
        6000,
        6500,
        7000,
        7500,
        8000,
        8500,
        9000,
        9500,
        10000,
        11000,
        12000,
        13000,
        14000,
        15000,
        16000,
        17000,
        18000,
        19000,
        20000,
        22500,
        25000,
        27500,
        30000,
        35000,
        40000,
        45000,
        50000,
        55000,
        60000,
        65000,
        70000,
        75000,
        150000
      ]
    };
  }

  handleChange = e => {
    this.setState({ value: e.target.value });
  };

  toggle(typeSelected) {
    if (this.state.typeSelected !== typeSelected) {
      this.setState({ typeSelected });
    }
  }

  handleNav (page) {
    const {history} = this.props
      history.push({
        pathname: `/search/${page}`
      })
  }

  error(message) {
    this.setState({ message });
  }

  handleChange = e => {
    this.setState({ value: e.target.value });
  };
  handleMakeChange(event) {
    this.setState({ makeSelected: event.target.value });
  }

  handleModelChange(event) {
    this.setState({ modelSelected: event.target.value });
  }

  handleFromPriceChange = event => {
    this.setState({ fromPrice: event.target.value });
  };
  handleToPriceChange = event => {
    this.setState({ toPrice: event.target.value });
  };

  async handleSearch(event) {
    event.preventDefault();
    let {
      makeSelected,
      fromPrice,
      toPrice
    } = this.state;
    if (makeSelected === null) {
      this.error('Make is missing');
      this.searchRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
      return;
    }
    const query = `one-search/${makeSelected}/${fromPrice}/${toPrice}/1/b`;
    this.props.onSearch(query);
  }

  keyToOption(key) {
    return key
      .split('-')
      .map(word => word.slice(0, 1).toUpperCase() + word.slice(1))
      .join(' ');
  }

  render() {
    const vehicles = veh_data.reduce(
      (acc, veh, i) => {
        let make = Object.keys(veh)[0];
        let vehModels = veh[make];
        return {
          makes: [
            ...acc.makes,
            <option key={make + i} value={make}>
              {this.keyToOption(make)}
            </option>
          ],
          models: {
            ...acc.models,
            [make]: [
              <option key={make + i + 0} value="any">
                Any Model
              </option>,
              vehModels.map((model, i) => {
                return (
                  <option key={make + model + i} value={model}>
                    {this.keyToOption(model)}
                  </option>
                );
              })
            ]
          }
        };
      },
      { makes: [], models: [] }
    );

    const selectMinValues = this.state.carPrices
      .filter((val) => {
        return val < this.state.toPrice
      })
      .map((val, i) => {
      return (
        <option style={{ fontWeight: 700}} key={val + i} value={val}>
          {val}
        </option>
      );
    });

    const selectMaxValues = this.state.carPrices
      .filter((val) => {
        return val > this.state.fromPrice
      })
      .map((val, i) => {
      return (
        <option style={{ fontWeight: 700}} key={val + i} value={val}>
          {val}
        </option>
      );
    });


    const selectedModels =
      this.state.makeSelected && this.state.makeSelected.length ? (
        vehicles.models[this.state.makeSelected]
      ) : (
        <option selected disabled>
          {/*Model (select make first)*/}
        </option>
      );
    return (
      <div
        className="col-lg-12"
        style={{ padding: '0px' }}
      >
        <header className="headerbg d-flex">
          <div
            className="col-sm-12 col-xs-12 offset-lg-0 col-lg-12 col-md-12"
            style={{ paddingLeft: '0px', paddingRight: '0px', position: 'relative' }}
          >
            <div className="container my-auto" style={{display: 'none'}}>
              <div className="bg-text">
                <div className="img-form-header"
                    style={{fontSize: '50px', fontWeight: 700, textAlign: 'center',
                      fontStyle: 'italic', borderRadius: '5px', backgroundColor: 'white',
                      textShadow: '0 1px, 1px 0, 1px 1px'}}>
                  25% OFF
                </div>
              </div>
            </div>
            <div className="container my-auto" style={{textAlign: 'center', position: 'absolute', bottom: '20px'}}>
              <Button variant="contained"
                      style={{color: 'black', backgroundColor: '#ffd700', display: 'None'}}
                      disableElevation
                      href="/search/shop"
              >
                SHOP NOW
              </Button>
            </div>
          </div>
        </header>
        <div style={{
          textAlign: "center",
          backgroundColor: "white",
          padding: "32px 0px 32px 0px",
          display: "None"
        }}>

          <div className="headings-div-successful">
            <h2 className="headings">Offers</h2>
          </div>
        </div>
        <div className="container" style={{ backgroundColor: "white", display: "None" }}>
          <div className="header-bottom ">
            <div className="row" style={{lineHeight: 1.25}}>
              <div className="col-12 col-md-6 col-sm-6 col-lg-6"
                   style={{paddingBottom: "40px"}}
              >
                <Card>
                  <CardImg
                    top
                    width="100%"
                    className="mx-auto car-img img-responsive home-categories"
                    src={cmctModelMen}
                    alt="Men"
                  />
                  <CardBody style={{ textAlign: 'center', paddingBottom: '15px', paddingTop: '25px'}}>
                    <div className="car-body-wrapper cards-body">
                      <CardSubtitle style={{ paddingBottom: '10px', fontSize: '13px'}}>
                        {/*eslint-disable-next-line*/}
                        <div className="home-categories-text">
                          DRINKS
                        </div>
                      </CardSubtitle>
                    </div>
                  </CardBody>
                  <div style={{textAlign: 'center'}}>
                    <Button variant="outlined"
                            style={{padding: '10px 15px 5px 15px', border: '2px solid black'}}
                            onClick={(event) =>
                              this.handleNav("drinks"
                              )}
                            size="sm">
                      {"SHOP DRINKS"}
                    </Button>
                  </div>
                </Card>

              </div>
              <div className="col-12 col-md-6 col-sm-6 col-lg-6"
                   style={{paddingBottom: "40px"}}
              >
                <Card>
                  <CardImg
                    top
                    width="100%"
                    className="mx-auto car-img img-responsive home-categories"
                    // src="../assets/images/cmct/cmct-model-in-car.jpg"
                    src={cmctModelWomen}
                    alt="Women"
                  />
                  <CardBody style={{ textAlign: 'center', paddingBottom: '15px', paddingTop: '25px'}}>
                    <div className="car-body-wrapper cards-body">
                      <CardSubtitle style={{ paddingBottom: '10px', fontSize: '13px'}}>
                        {/*eslint-disable-next-line*/}
                        <div className="home-categories-text">
                          SNACKS
                        </div>{' '}
                      </CardSubtitle>
                    </div>
                  </CardBody>
                  <div style={{textAlign: 'center'}}>
                    <Button variant="outlined"
                            style={{padding: '10px 15px 5px 15px', border: '2px solid black'}}
                            onClick={(event) =>
                              this.handleNav("snacks"
                              )}
                            size="sm">
                      {'SHOP SNACKS'}
                    </Button>
                  </div>
                </Card>

              </div>
            </div>

          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(ImgAndForm);
